
import { Settings, TenantSettings } from '@shared/core/services/configService';
import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '../../../shared/core/store';

@Component
export default class CtaFullWidth extends Vue {
  settings: TenantSettings = {};
  @Prop() title: any;
  @Prop() description: any;
  @Prop() image: any;
  @Prop({ default: false }) isFullPath!: boolean;
  @Prop() buttonText!: string;
  @Prop() buttonUrl!: string;

  async mounted() {
    this.settings = store.state.settings;
  }
}
